import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { RetailService } from '../../../core/routing/services/retail_api/retail.service';
import { StoresService } from '../../../core/routing/services/stores_api/stores.service';
import { countryConstants } from '../../../core/routing/constants/country.constant';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant';
import { RetailHq } from '../interface/retail.i';
import { Stores, UserRole } from '../stores/interface/store.i';
import { IPOSValidator } from '../../../common/validators/validators';
import { ActiveUsers } from './interface/active-users.i';
import { Enumvalues, ActiveUserConstants } from '../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { ActiveusersService } from '../../../core/routing/services/activeusers_api/activeusers.service';
import { RetailStoreCommonConstants } from '../../../common/constants/retailer-store.constant';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../common/services/common.service';

@Component({
  selector: 'iposcen-active-users',
  templateUrl: './active-users.component.html',
  styleUrls: ['./active-users.component.scss']
})
export class ActiveUsersComponent implements OnInit, OnDestroy {
  // invite user popup values
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('popOver') public popover: NgbPopover;
  displaySelectedRegional = new Map();
  isLoading = false;
  isUsersDataEmpty: boolean = false;
  isSearchFilter: boolean;
  globConst = GlobalConstants;
  selectedRoleInput = GlobalConstants.SELECT_ROLE;
  confirmConvert = false;
  userRole = sessionStorage.getItem('userRole');
  isRussian = localStorage.getItem('preferredLanguage') === 'ru' || localStorage.getItem('preferredLanguage') === 'tr';
  isIndonesia = localStorage.getItem('preferredLanguage') === 'id';
  isGerman = localStorage.getItem('preferredLanguage') === 'de';
  isUkraine = localStorage.getItem('preferredLanguage') === 'uk';
  isMexico = localStorage.getItem('preferredLanguage') === 'es-mx'
  isGreek = localStorage.getItem('preferredLanguage') === 'el';
  isEnglish = localStorage.getItem('preferredLanguage') === 'en-US';
  isPolish = localStorage.getItem('preferredLanguage') === 'pl';
  isThai = localStorage.getItem('preferredLanguage') === 'th';
  isHungarian = localStorage.getItem('preferredLanguage') === 'hu';
  isFinnish = localStorage.getItem('preferredLanguage') === 'fi';
  isDannish = localStorage.getItem('preferredLanguage') === 'da';
  isSwedish = localStorage.getItem('preferredLanguage') === 'sv';
  isCzech = localStorage.getItem('preferredLanguage') === 'cs';
  isNorwegian = localStorage.getItem('preferredLanguage') === 'nb';
  isRomanian = localStorage.getItem('preferredLanguage') === 'ro';
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  usrID = sessionStorage.getItem('userId');
  loadFlag: string;
  displayConvertStore: Stores[];
  filteredStore: Stores[];
  convertStoreData: any
  storeSearchValue = undefined;
  convertButtonEnable = true;
  convertDone = false;
  country: string;
  checkedUser: string;
  storeName: string;
  storeId: string;
  retailerID: string;
  retailerName: string;
  userEmailAddresses = [];
  usersDataUserIds = [];
  isEmailValid: boolean;
  isUserValid: boolean = false;
  invalidUserEmails: string[] = [];
  invalidUserErrorPretitle: string = '';
  invalidUserErrorPosttitle: string = '';
  inviteUserNote: string = GlobalConstants.INVITE_USER_NOTE;
  isEmailrequired: boolean;
  invitedEmailString: string;
  inviteUserForm: FormGroup;
  showInvitePopup: boolean;
  showsuccessInvitePopup: boolean;
  PAT_EMAIL = IPOSValidator.EMAIL;
  allRetailHqData: RetailHq[] = [];
  storesData: Stores[] = [];
  allCountries = [] as any;
  storesArray = [] as any;
  retailArray = [] as any;
  allRoles = [];
  allRolesWithPcFinder = [];
  displayDropDownRetail = [];
  valueForCountry: any;
  valueForRetailHq: any;
  valueForAssignedRetailHQ: any;
  valueForStore: any;
  valueForRole: string;
  showStore: boolean;
  showDeviceExecutive: boolean;
  showRetailer: boolean;
  selectedUserRole: string;
  isSubmitted: boolean;
  showAddStoresPopUp: boolean;
  usersData: ActiveUsers[] = [];
  allUserscsvData = [];
  filtercsvdata: [];
  page: number;
  expanded: boolean[] = [];
  showFrom: number;
  showTo: number;
  tableSize: number;
  showEditSave: boolean;
  valueForSearch: string;
  searchTag: string;
  searchData: string;
  valueForSearchinUsers: string;
  isAscendingSort = false;
  globalSortValue: string;
  searchClose: boolean;
  searchPlaceholder = GlobalConstants.SEARCHPLACEHOLDER;
  showDelete: boolean[] = [];
  selectedUsersToDelete: any;
  deleteSelectedUsers: string;
  disbaleDeleteIcon: boolean = false;;
  maxSize = 5;
  allActiveUserRetailHQs: string[] = [];
  allActiveUserRoles: string[] = [];
  allActiveUserCountries: string[] = [];
  closeFilter: boolean;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  retailHQDropdownSelectedValue: string;
  rolesDropdownSelectedValue: string;
  countriesDropdownSelectedValue: string;
  isShowForRetailHQUser: boolean;
  hovervalueForAssignedStore: string;
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  storeUser = GlobalConstants.STORE_USER;
  retailHQUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHQUser = ActiveUserConstants.REGIONAL_USER_ROLE
  retailhqFilterName = ActiveUserConstants.RETAILHQ_VALUE_FILTER;
  roleFilterName = ActiveUserConstants.ROLE_VALUE_FILTER;
  countryFilterName = ActiveUserConstants.COUNTRIES_VALUE_FILTER;
  location = ActiveUserConstants.COUNTRY_SORT;
  name = ActiveUserConstants.NAME_SORT.trim();
  email = ActiveUserConstants.EMAIL_SORT;
  retailer = ActiveUserConstants.RETAILER_SORT;
  store = ActiveUserConstants.STORENAME_SORT;
  profileCount = ActiveUserConstants.PROFILE_CREATED;
  enterAllEmailPlaceholderText = $localize`:@@active-users.email-textarea.enter-all-email:Enter all email addresses to invite to IPOS Central.`;
  loginUserRole = sessionStorage.getItem('userRole');
  NA = GlobalConstants.NA;
  checkEmailValue: string;
  checkDuplicate: boolean;
  checkRegistered: boolean;
  userEmails: [];
  noRecord = GlobalConstants.NO_RECORDS_FOUND;
  isEditable: number;
  editEmailValue: string;
  checkEdit: boolean;
  openDeleteModalPopup: boolean;
  openEditUserModalPopup: boolean;
  isDeleted: boolean;
  deleteMessage: string;
  deleteSuccessMessage: string;
  deleteUserId: string;
  checkDuplicateCount: number;
  userEmailsData: ActiveUsers[] = [];
  paginationCount: number;
  totalPages: number;
  retailUserId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  loggedInUserId = sessionStorage.getItem('userId');
  globalSortBy: string;
  emailVal = GlobalConstants.EMAIL;
  nameVal = StoresConstant.NAME_VALUE;
  retailHQVal = ActiveUserConstants.RETAILHQ_VALUE;
  storesVal = ActiveUserConstants.STORE_VALUE;
  countryName: any;
  storeNameDrop: any;
  retailnameDrop: any;
  locationSearch = GlobalConstants.ACTIVE_USRS_LOCATION;
  storeSearch = ActiveUserConstants.STORE_ROLE_INVITE;
  retailSearch = GlobalConstants.ACTIVE_USRS_RETL_HQ;
  retailHQValueCopy: any;
  assignedRetailHQ = [];
  storeValueCopy: any;
  locationValueCopy: any;
  convertUserData: any;
  private ngUnsubscribe = new Subject();
  convertRetailerData: any
  addMore = GlobalConstants.ADD_MORE;
  deleteAssignedRetail: any;
  showRetailGif = false;
  spllitedRetailerName = new Map();
  showEditRegionalHQModal = false;
  retaileHQList = [];
  copyRetailHQList = [];
  disableSaveChanges: boolean = true;
  removedRetails: string[] = [];
  updatedHQList = [];
  retailIdArrForGA = [];
  resultList: any;
  saveRegionalChanges = false;
  savedRegional = false;
  RegionalUserData = new Map();
  editedFirstName: string;
  editedLastName: string;
  editedEmailID: string;
  isEditedEmailCorrect: boolean = true;
  isUserInofUpdated: boolean;
  userDataToUpdate: any;
  isEmailAlreadyRegistered: boolean = false;
  multiSelectClicked: boolean = false;
  selectedUserRoles = [];
  selectedUsers = {};
  selectAll: number = 0;
  checkUncheckFlag: boolean = false;
  selectDeSelectAllFlag: boolean = false;
  objArray: any = [];
  sortBy: string;
  sortOrder: string;
  userRoleDeviceExec: boolean;
  retailerNamesList: any;
  retailerNamePcFinder: string;
  retailerNameLength: number;
  selectedCountValue: number;
  currentSelecteduserList: any = [];
  dataContainDisableItem: boolean = false;
  multiDeleteBtn = false;
  createdProfilesText = GlobalConstants.PROFILES_CREATED;
  completeUserList: ActiveUsers[] = [];
  isCompleteUserList: boolean = false;
  isDeleteConfirm: boolean = false;
  showPopupSpinner = false;

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private storesService: StoresService,
    private retailHqService: RetailService,
    private activeUserService: ActiveusersService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private cmnService: CommonService
  ) {
  }
  initilValue() {
    this.page = 1;
    this.showEditSave = false;
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.showAddStoresPopUp = false;
    this.showInvitePopup = false;
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.showsuccessInvitePopup = false;
    this.allRoles = this.userRole === GlobalConstants.INTEL_ADMIN ? [ActiveUserConstants.STORE_ROLE_INVITE, ActiveUserConstants.RETAILHQ_VALUE, ActiveUserConstants.PC_FINDER_USER]
      : [ActiveUserConstants.STORE_ROLE_INVITE, ActiveUserConstants.RETAILHQ_VALUE];
    if (this.userRole === GlobalConstants.INTEL_ADMIN) {
      this.allRoles.push(ActiveUserConstants.DEVICE_EXECUTIVE_VALUE);
    }
    this.valueForStore = null;
    this.valueForCountry = null;
    this.valueForRetailHq = null;
    this.valueForRole = StoresConstant.ROLE_VALUE;
    this.valueForSearch = StoresConstant.NAME_VALUE;
    this.valueForSearchinUsers = ActiveUserConstants.NAME;
    this.showRetailer = false;
    this.showStore = false;
    this.isSubmitted = false;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.openDeleteModalPopup = false;
    this.globalSortBy = StoresConstant.STORE_NAME;
    this.globalSortValue = StoresConstant.ASCENDING_ORDER;
    this.storeValueCopy = null;
    this.locationValueCopy = null;
    this.retailHQValueCopy = null;
    this.valueForAssignedRetailHQ = null;
  }
  ngOnInit(): void {
    this.initilValue();
    this.createFormGroupValuesforinvite();
    this.getAllActiveUsers();
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });
    this.selectedUserRoles = [];
    this.currentSelecteduserList = [];
  }
  getAllActiveUsers(filterString?: string) {
    if (this.isDeleteConfirm && this.usersData.length === 1) {
      this.page = this.page - 1;
    }
    this.activeUserService.getAllActiveUsers(this.page, filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getFilterUsersResponse => {
        this.usersData = (getFilterUsersResponse.user as ActiveUsers[]);
        if (this.userRole === GlobalConstants.INTEL_ADMIN) {
          this.getAllRetailHqData();
        }
        for (let i = 0; i < this.usersData?.length; i++) {
          if (this.usersData[i].userID === this.usrID) {
            this.usersDataUserIds.push(this.usersData[i]?.userID);
          }
          if (this.usersData[i]?.role == GlobalConstants.INTEL_ADMIN || this.usersData[i]?.userID == this.usrID) {
            this.dataContainDisableItem = true;
          }
        }
        // IIAT-1134
        this.userEmailsData = (getFilterUsersResponse.user as ActiveUsers[]);
        // IIAT-1134 end 
        this.paginationCount = (getFilterUsersResponse.paginationContext.totalItems);
        this.totalPages = (getFilterUsersResponse.paginationContext.totalPages);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.usersData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        } else {
          this.allActiveUserRoles = this.sortAlpabetically(getFilterUsersResponse.roleList);
          this.allActiveUserCountries = this.sortAlpabetically(getFilterUsersResponse.locationList);
          this.allActiveUserRetailHQs = this.sortAlpabetically(getFilterUsersResponse.retailerNameList);
        }
        this.isUsersDataEmpty = (this.usersData?.length === 0) || false;
        this.cmnService.setRetailGifValue(false);
      },
        error => {
          this.isUsersDataEmpty = true;
        });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createFormGroupValuesforinvite() {
    this.inviteUserForm = this.formBuilder.group({
      emailAddress: new FormControl('')
    });
  }

  inviteNewUser() {
    this.checkEdit = false;
    this.isSubmitted = false;
    this.showInvitePopup = true;
    this.showRetailer = false;
    if (this.userRole === 'storeUser') {
      // TODO
      this.showStore = true;
      this.showRetailer = false;
      this.selectedUserRole = 'storeUser';
      this.valueForRole = 'Store';
      this.retailHQValueCopy = null;
      this.storeId = sessionStorage.getItem('storeID');
      this.storeName = sessionStorage.getItem('storeName');
      this.retailerID = sessionStorage.getItem('retailerId');
      this.retailerName = sessionStorage.getItem('retailerName');
      this.valueForStore = sessionStorage.getItem('storeName');
      this.country = sessionStorage.getItem('location');
      this.valueForCountry = sessionStorage.getItem('location');
      this.locationValueCopy = { "CountryName": this.valueForCountry };
      this.storeValueCopy = { "storeId": this.storeId, "storeName": this.storeName };
    } else {
      this.showStore = false;
    }
  }

  onInviteStore() {
    this.isEmailValid = true;
    this.isSubmitted = true;
    this.checkEmailRequied();
    if (this.isEmailrequired) {
      if (this.userEmailAddresses?.length <= 0) {
        this.checkEmailvaild();
      }
      if (!this.checkDuplicate && !this.checkRegistered && this.isEmailValid &&
        (this.locationValueCopy !== null) &&
        (this.valueForRole !== StoresConstant.ROLE_VALUE) &&
        (this.userRole === 'intelAdmin' && this.selectedUserRole === 'storeUser' ? (((this.retailHQValueCopy !== null)) &&
          (this.storeValueCopy !== null)) : (((this.retailHQValueCopy !== null)) ||
            (this.storeValueCopy !== null)))
      ) {
        const inviteContent: UserRole = {
          email: this.userEmailAddresses?.length <= 1 ? (
            this.inviteUserForm.get('emailAddress').value ?
              this.inviteUserForm.get('emailAddress').value : this.userEmailAddresses[0]) : this.userEmailAddresses.toString(),
          role: this.selectedUserRole,
          retailerName: this.retailerName,
          retailerID: this.retailerID,
          storeID: this.storeId ? this.storeId : '',
          storeName: this.storeValueCopy ? this.storeValueCopy.storeName : '',
          location: this.locationValueCopy ? (this.userRole === GlobalConstants.STORE_USER ? this.locationValueCopy?.CountryName : this.locationValueCopy.nameInEng) : '',
          createdByUserID: sessionStorage.getItem('userId'),
          createdByName: sessionStorage.getItem('firstname')
        };
        this.storesService.inviteStoreUser(inviteContent)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(data => {
            if (data.responseContext.success === true) {
              this.showInvitePopup = false;
              this.invitedEmailString = this.userEmailAddresses?.length > 1 ?
                this.userEmailAddresses?.length + ' users' : (this.inviteUserForm.get('emailAddress').value ? this.inviteUserForm.get('emailAddress').value : this.userEmailAddresses[0]);
              this.showsuccessInvitePopup = true;
              this.userEmailAddresses = [];
              this.inviteUserForm.reset();
              this.locationValueCopy = null;
              this.valueForRole = StoresConstant.ROLE_VALUE;
            }
          }, error => {
            // changes for IIT2-22817 & IIT2-22896
           if(error.responseContext.success === false){
              this.isUserValid = true;
              this.invalidUserEmails = error.responseContext.exceptionResponse.existingEmails;
              this.invalidUserErrorPretitle = GlobalConstants.INVALID_USER_ERROR_MSG_PRETITLE;
              this.invalidUserErrorPosttitle = GlobalConstants.INVALID_USER_ERROR_MSG_POSTTITLE;
        }
      });
      }
    }

    window['dataLayer'].push({
      'new_active_user_added': true
    })
  }

  onCloseInvite() {
    this.showInvitePopup = false;
    this.inviteUserForm.reset();
    this.retailerName = '';
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.checkDuplicate = false;
    this.checkDuplicateCount = 0;
    this.userEmailAddresses = [];
    this.invalidUserEmails = [];
    this.isUserValid = false;
    this.allCountries = [];
    this.storeValueCopy = null;
    this.locationValueCopy = null;
    this.retailHQValueCopy = null;
    this.valueForRole = StoresConstant.ROLE_VALUE;
    this.valueForRetailHq = null;
    this.valueForStore = null;
    this.valueForCountry = null;
    this.valueForAssignedRetailHQ = null;
  }

  onCloseSuccessPopup() {
    this.allCountries = [];
    this.invitedEmailString = '';
    this.storeName = '';
    this.retailerName = '';
    this.showsuccessInvitePopup = false;
    this.showRetailer = false;
    this.showStore = false;
    this.searchClose = false;
    this.getAllActiveUsers();
    this.searchData = ActiveUserConstants.EMPTY_VALUE;
    this.storeValueCopy = null;
    this.locationValueCopy = null;
    this.retailHQValueCopy = null;
    this.valueForRetailHq = null;
    this.valueForStore = null;
    this.valueForCountry = null;
    this.valueForAssignedRetailHQ = null;
  }

  addEmail() {
    this.isEditable = undefined;
    this.checkEdit = false;
    this.checkEmailRequied();
    if (this.isEmailrequired) {
      this.checkEmailvaild();
      this.checkDuplicateCount = 0;
      const emailExists = this.userEmailsData
        .find(resp => resp.email === this.inviteUserForm.get('emailAddress').value
          .replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      if (this.userEmailAddresses.length > 0) {
        if (this.userEmailAddresses.includes(this.inviteUserForm.get('emailAddress').value
          .replace(/\n/ig, ''))) {
          this.checkDuplicate = true;
        } else {
          this.checkDuplicate = false;
        }
      }
      if (this.isEmailValid && !this.checkDuplicate && !this.checkRegistered) {
        this.userEmailAddresses.push(this.inviteUserForm.get('emailAddress').value
          .trim()
          .replace(/\s/g, ''));
        this.inviteUserForm.controls.emailAddress.reset();
      }
    }
  }

  onKeyUp(event) {
    if (event.key === 'Enter') {
      this.addEmail();
    } else if (event.key === ',' || event.key === ';') {
      this.checkEmailRequied();
      if (this.isEmailrequired) {
        const re = this.PAT_EMAIL;
        this.isEmailValid = re.test(this.inviteUserForm.get('emailAddress').value
          .slice(0, -1)
          .trim());
        if (this.isEmailValid) {
          this.userEmailAddresses.push(this.inviteUserForm.get('emailAddress').value
            .slice(0, -1)
            .trim());
          this.inviteUserForm.controls.emailAddress.reset();
        }
      }
    } else if ((event.key === 'Backspace') || (event.key === 'Delete')) {
      const emailExists = this.userEmailsData
        .find(resp => resp.email === this.inviteUserForm.get('emailAddress').value
          .replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      this.isEmailValid = true;
      this.checkDuplicate = false;
      this.checkEmailRequied();
      if (this.isEmailrequired && this.inviteUserForm.get('emailAddress').value) {
        this.checkEmailvaild();
      }
    }
  }

  deleteEmail(indexval: number) {
    if (indexval > -1) {
      this.userEmailAddresses = [...this.userEmailAddresses.slice(0, indexval), ...this.userEmailAddresses.slice(indexval + 1)];
    }
    const emailValue = this.inviteUserForm.get('emailAddress').value;
    if (emailValue && this.userEmailAddresses.includes(emailValue.replace(/\n/ig, ''))) {
      this.checkDuplicate = true;
    } else {
      this.checkDuplicate = false;
    }
    // changes for IIT2-22817 & IIT2-22896
    this.invalidUserEmails = this.invalidUserEmails?.filter(email => this.userEmailAddresses.includes(email)) || [];
    this.isUserValid = this.invalidUserEmails.length > 0;
  }

  checkEmailvaild() {
    const re = this.PAT_EMAIL;
    this.isEmailValid = re.test(this.inviteUserForm.get('emailAddress').value
      .trim()
      .replace(/[\r\n]+/gm, ''));
  }

  checkEmailRequied() {
    this.isEmailrequired = this.userEmailAddresses?.length || this.inviteUserForm.get('emailAddress').value;
  }

  getAllStoresByUserID() {
    // IIT2-1531
    this.storesService.getAllStores(this.globalSortBy, this.globalSortValue, this.filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllStoresResponse => {
        this.storesData = (getAllStoresResponse.store as Stores[]);
        this.storesArray = this.storesData.map(storeData => storeData.storeName);
      });
    // IIT2-1531 end
  }

  onFilter(selectedFilterName: string, selectedValue: string) {
    this.closeFilter = true;
    switch (selectedFilterName) {
      case ActiveUserConstants.RETAILHQ_VALUE_FILTER:
        this.retailHQDropdownSelectedValue = selectedValue;
        break;
      case ActiveUserConstants.ROLE_VALUE_FILTER:
        this.rolesDropdownSelectedValue = this.spell(selectedValue);
        break;
      case ActiveUserConstants.COUNTRIES_VALUE_FILTER:
        this.countriesDropdownSelectedValue = selectedValue;
        break;
      default:
        return;
    }
    //IIT2-6638 Added encodeURIComponent to handle &amp in queryParameters
    this.selectFilterQueue[selectedFilterName] = encodeURIComponent(selectedValue);
    this.getFilterSearchData();
    this.closeExpandedTab();
    this.selectedUsers = {};// Reset filters
    this.dataContainDisableItem = false;
    this.selectedUserRoles = [];
    this.currentSelecteduserList = [];
    this.selectAll = 0;
    this.checkUncheck();
  }
  closeExpandedTab() {
    let temp = new Array(this.expanded.length).fill(false);
    this.expanded = [...temp];
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllActiveUsers(this.filterString);
    } else {
      this.getAllActiveUsers();
    }
    this.closeExpandedTab();
    //this.selectedUsers = {};// Reset filters
    this.dataContainDisableItem = false;
    this.selectedUserRoles = [];
    this.currentSelecteduserList = [];
    this.selectAll = 0;
    this.checkUncheck();
  }

  sortAlpabetically(arrayValue: any): string[] {
    return arrayValue.sort((a, b) => a?.trim().toLowerCase().localeCompare(b?.trim().toLowerCase()));
  }

  clearFilter(filterName?: string) {
    if (filterName && filterName === ActiveUserConstants.RETAILHQ_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allActiveUserRetailHQs = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.retailHQDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === ActiveUserConstants.ROLE_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.allActiveUserRoles = [];
      this.rolesDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === ActiveUserConstants.COUNTRIES_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allActiveUserCountries = [];
      this.countriesDropdownSelectedValue = '';
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.getFilterSearchData();
    } else {
      this.selectFilterQueue = {};
      this.allActiveUserRoles = [];
      this.allActiveUserCountries = [];
      this.allActiveUserRetailHQs = [];
      this.getFilterSearchData();
      this.closeFilter = false;
      this.retailHQDropdownSelectedValue = '';
      this.rolesDropdownSelectedValue = '';
      this.countriesDropdownSelectedValue = '';
    }
    this.closeExpandedTab();
    this.selectedUsers = {};// Reset filters
    this.selectedUserRoles = [];
    this.currentSelecteduserList = [];
    this.selectAll = 0;
    this.dataContainDisableItem = false;
    this.checkUncheck();
  }

  onRoleChange(data: string) {
    this.isSubmitted = false;
    this.allCountries = countryConstants;
    if (data === RetailStoreCommonConstants.STORE_VALUE) {
      this.valueForRole = RetailStoreCommonConstants.STORE_VALUE;
      this.showDeviceExecutive = false;
      this.showStore = true;
      this.showRetailer = false;
      this.retailerID = '';
      this.retailerName = '';
      this.retailHQValueCopy = null;
      this.valueForAssignedRetailHQ = null;
      this.selectedUserRole = 'storeUser';
      this.valueForCountry = null;
      this.storeValueCopy = null;
      this.locationValueCopy = null;
      this.valueForRetailHq = null;
      this.getAllStoresByUserID();
    } else if (data === RetailStoreCommonConstants.RETAILHQ_VALUE) {
      this.valueForRole = data === RetailStoreCommonConstants.RETAILHQ_VALUE ? RetailStoreCommonConstants.RETAILHQ_VALUE : '';
      this.showDeviceExecutive = false;
      this.showStore = false;
      this.showRetailer = true;
      this.storeId = '';
      this.storeName = '';
      this.storeValueCopy = null;
      this.selectedUserRole = data === RetailStoreCommonConstants.RETAILHQ_VALUE ? 'retailHQUser' : '';
      this.locationValueCopy = null;
      this.valueForCountry = null;
      this.valueForStore = null;
      this.resetAll();
      this.getAllRetailHqData();
      if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) {
        this.valueForRetailHq = sessionStorage.getItem('retailerName');
        this.retailerID = sessionStorage.getItem('retailerId');
        this.retailerName = sessionStorage.getItem('retailerName');
        this.retailHQValueCopy = { "retailerID": this.retailerID, "retailerName": this.retailerName };
      }
    } else if (data === RetailStoreCommonConstants.DEVICE_EXECUTIVE_VALUE) {
      this.valueForRole = RetailStoreCommonConstants.DEVICE_EXECUTIVE_VALUE;
      this.showDeviceExecutive = true;
      this.showStore = false;
      this.showRetailer = true;
      this.storeId = '';
      this.storeName = '';
      this.storeValueCopy = null;
      this.selectedUserRole = 'deviceExecutive';
      this.locationValueCopy = null;
      this.valueForCountry = null;
      this.valueForStore = null;
      this.getAllRetailHqData();
      if (this.userRole === GlobalConstants.ADMIN) {
        this.valueForRetailHq = sessionStorage.getItem('retailerName');
        this.retailerID = sessionStorage.getItem('retailerId');
        this.retailerName = sessionStorage.getItem('retailerName');
        this.retailHQValueCopy = { "retailerID": this.retailerID, "retailerName": this.retailerName };
      }
    }
  }
  getTranslatedLoc(name: string) {
    const countryTranslated = countryConstants?.find(i => i?.nameInEng === name);
    return (countryTranslated?.CountryName || name);
  }
  onTableDataChange(event) {
    this.page = event;
    this.getAllActiveUsers(this.filterString);
  }

  getUsersbyID(indexValue) {
    this.expanded[indexValue] = !this.expanded[indexValue];
    if (this.expanded[indexValue]) {
      this.showDelete[indexValue] = true;
    } else {
      this.showDelete[indexValue] = false;
    }
  }

  onSelectChange(value) {
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = ActiveUserConstants.NAME_SEARCH;
      this.valueForSearchinUsers = ActiveUserConstants.NAME;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = ActiveUserConstants.EMAIL_SEARCH;
      this.valueForSearchinUsers = ActiveUserConstants.EMAIL;
    } else if (value === Enumvalues.VALUE_3) {
      this.searchTag = ActiveUserConstants.RETAILHQ_VALUE_SEARCH;
      this.valueForSearchinUsers = ActiveUserConstants.RETAILHQ_VALUE;
    } else if (value === Enumvalues.VALUE_4) {
      this.searchTag = ActiveUserConstants.STORE_VALUE_SEARCH;
      this.valueForSearchinUsers = ActiveUserConstants.STORE_VALUE;
    }
  }

  searchActiveUsers(searchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = ActiveUserConstants.NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue = {};// To clear previous seletion
      this.searchQueue[this.searchTag] = encodeURIComponent(searchData);
      this.getFilterSearchData();
    } else {
      this.getAllActiveUsers();
      this.page = 1;
    }
  }

  searchtheUserssonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchActiveUsers(searchData);
  }

  sort(sortKey: string) {
    if (this.loginUserRole !== 'storeUser') {
      switch (sortKey) {
        case (ActiveUserConstants.NAME_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.NAME_SORT);
          break;
        case (ActiveUserConstants.EMAIL_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.EMAIL_SORT);
          break;
        case (ActiveUserConstants.RETAILER_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.RETAILER_SORT);
          break;
        case (ActiveUserConstants.STORENAME_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.STORENAME_SORT);
          break;
        case (ActiveUserConstants.COUNTRY_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.COUNTRY_SORT);
          break;
        case (ActiveUserConstants.CREATED_BY_SORT):
          this.sortingTableWithAscandDesc(ActiveUserConstants.CREATED_BY_SORT);
          break;
        case (ActiveUserConstants.PROFILE_CREATED):
          this.sortingTableWithAscandDesc(ActiveUserConstants.PROFILE_CREATED);
          break;
        default: {
        }
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = ActiveUserConstants.EMPTY_VALUE;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? ActiveUserConstants.ASCENDING_ORDER :
      RetailStoreCommonConstants.DESCENDING_ORDER;
    this.sortQueue[ActiveUserConstants.SORT_BY] = tempval;
    this.sortQueue[ActiveUserConstants.SORT_TYPE] = sortOrder;
    // this.sortBy=tempval;
    // this.sortOrder=sortOrder;      
    this.getFilterSearchData();
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.searchQueue = {};
      this.getFilterSearchData();
      this.searchData = ActiveUserConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
    }
  }

  addBorder(wrap: HTMLElement) {
    wrap.classList.add('onfocus-border');
  }

  removeBorder(wrap: HTMLElement) {
    wrap.classList.remove('onfocus-border');
  }

  showDeleteUserPopup(userId: string, userName: string, userRole: string) {
    this.isDeleteConfirm = false;
    this.multiDeleteBtn = false;
    this.deleteUserId = userId;
    this.openDeleteModalPopup = true;
    this.isDeleted = true;
    this.deleteMessage = userName;
    this.userRoleDeviceExec = userRole === 'deviceExecutive';
  }

  deleteUser() {
    let tempuid;
    if (this.multiSelectClicked) {
      let checkArr = [];
      for (let i in this.selectedUsers) {
        if (this.selectedUsers[i]) {
          checkArr.push(i);
        }
      }
      tempuid = { userID: checkArr };
    } else {
      tempuid = {
        userID: [
          this.deleteUserId
        ]
      };
    }
    this.activeUserService.deleteUser(tempuid)
      .subscribe(data => {
        if (data) {
          this.isDeleted = false;
          let timer = (!this.multiSelectClicked) ? 2000 : 3000;
          this.showPopupSpinner = true;
          setTimeout(_ => {
            this.showPopupSpinner = false;
            this.isDeleteConfirm = true;
            this.getAllActiveUsers(this.filterString);
          }, timer);
        }
      });
  }

  closeDeleteUserModal(cancelFlag?: string) {
    this.openDeleteModalPopup = false;
    if (!cancelFlag) {
      this.multiSelectClicked = false;
      this.selectAll = 0;
      this.selectedUsers = {};
      this.selectedUserRoles = [];
      this.currentSelecteduserList = [];
      this.checkUncheckFlag = false;
    }
  }

  checkRole(data) {
    if (data === 'storeUser') {
      return 'btn btn-primary store-color';
    } else if (data === 'retailHQUser' || data === 'regionalHQ') {
      return 'btn btn-primary retailer-color';
    } else if (data === 'nonConnectedUser') {
      return 'btn btn-primary-non-connected non-connected-color';
    }
    // commenting srt or pc finder role code
    // else if (data === 'srtUser') {
    //   return 'btn btn-primary pc-finder-color';
    // }
    else {
      return 'btn btn-primary';
    }
  }

  addSpaces(data) {
    if (data?.length) {
      return data.replace(',', ', ');
    }
  }

  spell(data) {
    if (data === 'retailHQUser') {
      return ActiveUserConstants.RETAILHQ_VALUE;
    } else if (data === 'storeUser') {
      return ActiveUserConstants.STORE_ROLE_INVITE;
    } else if (data === 'nonConnectedUser' || data === 'nonConnecteduser') {
      return ActiveUserConstants.NON_CONNECTED_LABEL;
    } else if (data === 'intelAdmin') {
      return ActiveUserConstants.INTEL_ADMIN;
    } else if (data === 'regionalHQ') {
      return ActiveUserConstants.REGIONAL_HQ;
    } else if (data === 'deviceExecutive') {
      return ActiveUserConstants.DEVICE_EXECUTIVE_VALUE;
    }
    // commenting srt or pc finder user role code
    //  else if (data === GlobalConstants.SRT_ADMIN) {
    //   return ActiveUserConstants.PC_FINDER_USER;
    // }
  }

  downloadCsvFile() {
    if (navigator.onLine) {
      const userrequestBody = {
        csvHeaders: []
      };
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_FNAME);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_LNAME);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_EMAIL);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_LAUNGUAGE);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_RETL_HQ);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_RETLR_ID);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_LOCATION);
      userrequestBody.csvHeaders.push(GlobalConstants.ACTIVE_USRS_CREATED_BY);
      userrequestBody.csvHeaders.push(GlobalConstants.CONVERTED_BY);
      if (this.userRole === GlobalConstants.INTEL_ADMIN) {
        userrequestBody.csvHeaders.push(GlobalConstants.PROFILES_CREATED);
      }
      if (this.filterString) {
        if (this.userRole === GlobalConstants.INTEL_ADMIN) {
          this.activeUserService
            .postdownloadcsvUsersbyFilter(this.filterString, userrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllUsersIntelAdminFilterResponse => {
              this.downloadCsv(getAllUsersIntelAdminFilterResponse);
            });
        }
        else if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.activeUserService
            .postdownloadcsvUsersbyFilterRetailHq(this.filterString, userrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllStoresRetailHqResponse => {
              this.downloadCsv(getAllStoresRetailHqResponse);
            });
        }
        else {
          // TODO
        }
      }
      else {
        if (this.userRole === GlobalConstants.INTEL_ADMIN) {
          this.activeUserService.postAllUsersForCsv(userrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllUsersIntelAdminResponse => {
              this.downloadCsv(getAllUsersIntelAdminResponse);
            });
        }
        else if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.activeUserService.postAllUsersRetailHqForCsv(userrequestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getFilterUsersRetailHqResponse => {
              this.downloadCsv(getFilterUsersRetailHqResponse);
            });
        }
        else {
          // TODO
        }
      }

    } else {
      // TODO
    }
  }

  downloadCsv(csvResponse) {
    this.allUserscsvData = csvResponse;
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.USERS_ACTIVEUSERS_CSV_FILENAME;
    let userfilename = month + '_' + day + '_' + year + '_' + filename;
    const blob = new Blob(['\ufeff' + this.allUserscsvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  onPaste(event) {
    event.preventDefault();
    this.checkDuplicateCount = 0;
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    this.userEmails = pastedText.split(/,|;/);
    this.userEmails.forEach(val => {
      if (!val) {
        return;
      }
      const re = this.PAT_EMAIL;
      this.isEmailValid = re.test(val);
      const emailExists = this.userEmailsData.find(resp => resp.email === val);
      if (emailExists) {
        this.checkRegistered = emailExists ? true : false;
        this.inviteUserForm.patchValue({ emailAddress: val });
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
      }
      if (this.isEmailValid && this.userEmailAddresses.indexOf(val) === -1 && !this.checkRegistered) {
        this.userEmailAddresses.push(val);
      }
    });
  }

  editEmail(event) {
    if (this.checkEdit) {
      return false;
    }
    this.checkEdit = true;
    const emailValue = this.userEmailAddresses[event];
    this.isEditable = event;
    this.userEmailAddresses.splice(event, 1);
    this.inviteUserForm.patchValue({ emailAddress: emailValue });
  }

  avoidSpecialChar(event) {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9_.\-@+]/, '');
    event.target.value = event.target.value
      .replace(/\.+/g, '.')
      .replace(/_+/g, '_')
      .replace(/-+/g, '-')
      .replace(/@+/g, '@');
    event.target.value = event.target.value
      .replace(/^\./g, '')
      .replace(/^_/g, '')
      .replace(/^-/g, '')
      .replace(/^@/g, '');
    event.target.value = event.target.value
      .replace(/@\./g, '@')
      .replace(/@_/g, '@')
      .replace(/@-/g, '@');
    event.target.value = event.target.value
      .replace(IPOSValidator.AVOID_CONSECUTIVE, '$1');
  }
  getAllRetailHqData() {
    this.retailHqService.getAllRetailerInfo(StoresConstant.RETAILER_NAME_SORT, RetailStoreCommonConstants.ASCENDING_ORDER)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        this.allRetailHqData = (result.retailer as RetailHq[]);
        this.isUsersDataEmpty = (this.usersData?.length === 0) || false;
      },
        error => {
          this.isUsersDataEmpty = true;
        });
  }
  countrySearchFn(term: string, item: any) {
    return item?.CountryName.toLocaleLowerCase()?.startsWith(term?.toLocaleLowerCase());
  }

  onRetailChange(event) {
    this.retailHQValueCopy = event ? event : null;
    this.retailerID = event ? event.retailerId : '';
    this.retailerName = event ? event.retailerName : '';
    this.filterStores();
  }

  clearRetailerName() {
    let convertDisplaySelectedRegionalToArray = Array.from(this.displaySelectedRegional.keys());
    const result = convertDisplaySelectedRegionalToArray.filter(element => this.valueForAssignedRetailHQ.every(item => !element.includes(item)));
    if (result.length) {
      this.displaySelectedRegional.delete(result[0]);
    }
  }

  onAssignedRetailChange(event) {
    if (!event.type) {
      this.assignedRetailHQ = event;
    }
    this.allRetailHqData.forEach(data => {
      if (event.includes(data.retailerId)) {
        this.displaySelectedRegional.set(data.retailerId, data.retailerName);
      }
    });
    // commenting srt or pc finder user role code
    // this.retailerNamePcFinder = this.getRetailerNamesList();
    // const stringArrays: string[] = this.retailerNamePcFinder.split(',').map((str) => str.trim());
    // this.retailerNameLength = stringArrays.length;
  }

  // commenting srt or pc finder user role code
  // getRetailerIdsList() {
  //   return Array.from(this.displaySelectedRegional.keys()).join(',');
  // }

  // getRetailerNamesList(): string {
  //   return Array.from(this.displaySelectedRegional.values()).join(',');
  // }

  bindRetailHQ(retailerName, retailerId, event) {
    let childNodesList = [];
    childNodesList = Array.from(event.target.childNodes);
    let result = childNodesList.filter(item => item.nodeName === '#text');
    if ((event.target.childNodes.length > 0 && result.length > 0) || event.target.checked) {
      this.retaileHQList.push(retailerName);
    } else {
      this.retaileHQList = this.retaileHQList.filter(item => item !== retailerName);
    }
    this.retaileHQList.sort();
    if (!retailerId.type) {
      this.assignedRetailHQ = retailerId;
    }
    this.allRetailHqData.forEach(data => {
      if (retailerId.includes(data.retailerId)) {
        this.displaySelectedRegional.set(data.retailerId, data.retailerName);
        retailerName = data.retailerName;
      }
    });
    this.checkDiff();
    if (event?.target?.checked) {
      const index = this.removedRetails.indexOf(retailerName);
      if (index > -1) {
        this.removedRetails.splice(index, 1);
      }
    } else {
      if (!this.removedRetails.includes(retailerName)) {
        this.removedRetails.push(retailerName);
      }
    }
  }

  clearRetailHQ(eachRetailHQ) {
    const index = this.retaileHQList.indexOf(eachRetailHQ);
    if (index > -1) {
      this.retaileHQList.splice(index, 1);
    }
    if (!this.removedRetails.includes(eachRetailHQ)) {
      this.removedRetails.push(eachRetailHQ);
    }
    this.prefillData();
    this.checkDiff();
  }

  onStoreChange(event) {
    this.isSubmitted = false;
    this.storeValueCopy = event ? event : null;
    this.storeId = event ? event.storeId : '';
    this.storeName = event ? event.storeName : '';
    this.retailerID = event ? event.retailerId : '';
    this.retailerName = event ? event.retailerName : '';
    this.hovervalueForAssignedStore = event ? event.storeName : '';
  }

  onCountryChange(countryData) {
    this.isSubmitted = false;
    this.locationValueCopy = countryData ? countryData : null;
  }
  openPopup(modal, data) {
    this.convertUserData = data;
    this.modalService.open(modal);
    this.allRetailHqData = this.allRetailHqData.filter(item => item.retailerId !== this.convertUserData.retailerID);
    this.displayDropDownRetail = this.allRetailHqData;
  }
  selectToConvert(data, which) {
    if (which === GlobalConstants.RETAIL_HQ) {
      this.convertRetailerData = data;
      this.displayConvertStore = [];
      this.getStoreData();
      this.convertStoreData = undefined;
      this.storeSearchValue = undefined;
    } else {
      this.convertStoreData = data;
    }
    this.checkConvertFields();
  }
  checkConvertFields(data?) {
    if (data) {
      this.selectedRoleInput = data;
    }
    if (this.selectedRoleInput === GlobalConstants.RETAIL_HQ) {
      this.convertButtonEnable = this.convertRetailerData ? false : true;
      this.storeSearchValue = undefined;
      this.convertStoreData = undefined;
    } else {
      this.convertButtonEnable = !(this.convertRetailerData && this.convertStoreData);
    }
  }
  getStoreData() {
    if (this.convertRetailerData) {
      this.storesService.getStoreByUserIDRetailer(this.convertRetailerData.retailerName)
        .subscribe(res => {
          this.displayConvertStore = (res.store as Stores[]);
        });
    }
  }

  filterStores() {
    this.valueForStore = null;
    this.storesService.getStoreByUserIDRetailer(this.retailHQValueCopy?.retailerName.trim())
      .subscribe(res => {
        this.filteredStore = (res.store as Stores[]);
      });

  }
  convert() {
    let payload = {
      userID: this.convertUserData.userID,
      email: this.convertUserData.email,
      role: this.selectedRoleInput,
      retailerID: this.convertRetailerData.retailerId,
      retailerName: this.convertRetailerData.retailerName,
    }
    if (this.selectedRoleInput === GlobalConstants.STORE) {
      payload['storeID'] = this.convertStoreData.storeId;
      payload['storeName'] = this.convertStoreData.storeName;
    }
    this.retailHqService.convertUserPatchCall(payload)
      .subscribe(res => {
        this.convertDone = true;
        setTimeout(_ => {
          this.getAllActiveUsers(this.filterString);
          this.closeExpandedTab();
        }, 2000);
      });
  }
  resetAll(val?: string) {
    if (val !== 'cancelConvertPopup') {
      this.clearFilter();
    }
    this.assignedRetailHQ = [];
    this.displaySelectedRegional.clear();
    this.valueForAssignedRetailHQ = null;
    this.convertDone = false;
    this.convertRetailerData = undefined;
    this.convertStoreData = undefined;
    this.confirmConvert = false;
    this.selectedRoleInput = GlobalConstants.SELECT_ROLE;
    this.convertButtonEnable = true;
    this.displayConvertStore = [];
  }

  deleteAssignedRetailHQ(value: any) {
    this.displaySelectedRegional.delete(value);
    let temp = [...this.valueForAssignedRetailHQ];
    temp.splice(this.valueForAssignedRetailHQ.indexOf(value), 1);
    this.valueForAssignedRetailHQ = [...temp];
    this.assignedRetailHQ = [...temp];
    if (!this.removedRetails.includes(value)) {
      this.removedRetails.push(value);
    }
    this.checkDiff();
  }

  converToRegional() {
    this.clearRetailerName();
    let payload = {
      userID: this.convertUserData.userID,
      email: this.convertUserData.email,
      role: GlobalConstants.REGIONALHQ,
      location: this.convertUserData.location,
      retailerIDMap: {}
    }
    payload.retailerIDMap[this.convertUserData.retailerID] = this.convertUserData.retailerName;
    this.displaySelectedRegional.forEach((value, id) => {
      payload.retailerIDMap[id] = value;
    });
    this.retailHqService.convertUserPatchCall(payload)
      .subscribe(res => {
        this.convertDone = true;
        setTimeout(_ => {
          this.getAllActiveUsers(this.filterString);
          this.closeExpandedTab();
        }, 2000);
      });
  }
  masterConvert() {
    if (this.assignedRetailHQ.length)
      this.converToRegional();
    else
      this.convert()
  }
  checkIfSingle(retailerName, retailerID?) {
    if (!retailerName) {
      return true;
    }
    if (retailerName.includes(',')) {
      if (retailerID)
        this.spllitedRetailerName.set(retailerID, retailerName.split(','));
      return false;
    } else {
      return true;
    }
  }

  openRegionalHQModal(retailerID, data) {
    this.isSearchFilter = false;
    this.retaileHQList = this.spllitedRetailerName.get(retailerID);
    if (this.retaileHQList) {
      this.showEditRegionalHQModal = true;
      let retailID = data.retailerID.split(',');
      let retName = data.retailerName.split(',');
      this.retailIdArrForGA = retailID; //for GA
      for (let i = 0; i < retailID.length; i++) {
        this.RegionalUserData.set(retailID[i], retName[i])
      }
      this.RegionalUserData = new Map([...this.RegionalUserData]);
      this.resultList = data;
      this.retaileHQList.sort();
      this.copyRetailHQList = JSON.parse(JSON.stringify([...this.retaileHQList]));
      this.checkDiff();
    }
    this.removedRetails = [];
    this.prefillData();
  }

  prefillData() {
    this.valueForAssignedRetailHQ = [];
    this.allRetailHqData.forEach(ele => {
      if (this.retaileHQList?.includes(ele.retailerName)) {
        this.valueForAssignedRetailHQ.push(ele.retailerId);
      }
    });
  }


  closePopup() {
    this.showEditRegionalHQModal = false;
    this.saveRegionalChanges = false;
  }

  saveRegionalHQModal(retailerID) {
    this.displaySelectedRegional = new Map([...this.RegionalUserData].concat([...this.displaySelectedRegional]))
    this.saveRegionalChanges = true;
    this.updatedHQList = this.spllitedRetailerName.get(retailerID);
  }

  closeRegionalPopup() {
    this.showEditRegionalHQModal = true;
    this.saveRegionalChanges = false;
  }

  masterSaveRegional(filterName?) {
    this.savedRegional = true;
    this.saveRegionalChanges = false;

    let payload = {
      userID: this.resultList.userID,
      email: this.resultList.email,
      location: this.resultList.location,
      role: GlobalConstants.REGIONALHQ,
      retailerIDMap: {}
    }

    if (!this.resultList.retailerName.includes(',')) {
      payload.retailerIDMap[this.resultList.retailerID] = this.resultList.retailerName;
    }

    this.displaySelectedRegional.forEach((value, id) => {
      payload.retailerIDMap[id] = value;
    });

    Object.entries(payload.retailerIDMap).forEach(([key, value]) => {
      if (!this.retaileHQList.includes(value)) {
        delete payload.retailerIDMap[key]
      }
    });
    //GA start
    if (this.retaileHQList.length !== this.retailIdArrForGA.length) {
      this.googleAnalyticsService.hQAccAssignedtoRegUserChanged();
    } else {
      let isIdSame = true;
      Object.entries(payload.retailerIDMap).forEach(([key]) => {
        if (!this.retailIdArrForGA.includes(key)) { //checking if any retaileId is changed
          isIdSame = false;
        }
      });
      if (!isIdSame) { this.googleAnalyticsService.hQAccAssignedtoRegUserChanged(); }
    } //GA ends

    this.retailHqService.convertUserPatchCall(payload)
      .subscribe(res => {
        setTimeout(_ => {
          this.getAllActiveUsers(this.filterString);
          this.closeExpandedTab();
        }, 2000);
      });
  }

  closeSavedPopup() {
    this.savedRegional = false;
    this.showEditRegionalHQModal = false;
    this.saveRegionalChanges = false;
    this.closeExpandedTab();
  }

  onSearch($event) {
    this.isSearchFilter = $event.term.length > 0;
  }

  openEditUserModal(currentUserInfo) {
    this.userDataToUpdate = currentUserInfo;
    this.openEditUserModalPopup = true;
    this.resetEditUserModalData();
  }

  closeEditUserModal() {
    this.openEditUserModalPopup = false;
    this.isUserInofUpdated = false;
    this.resetEditUserModalData();

  }

  resetEditUserModalData() {
    this.isEmailAlreadyRegistered = false;
    this.isEditedEmailCorrect = true;
    this.editedFirstName = '';
    this.editedLastName = '';
    this.editedEmailID = '';
  }

  updateUserInfo() {
    const re = this.PAT_EMAIL;
    this.isEmailAlreadyRegistered = false;
    this.isEditedEmailCorrect = re.test(this.editedEmailID.trim().replace(/[\r\n]+/gm, ''));
    if (this.isEditedEmailCorrect) {
      let userData = {
        firstName: this.editedFirstName,
        lastName: this.editedLastName,
        email: this.editedEmailID,
        userID: this.userDataToUpdate.userID
      }
      this.activeUserService.transferUser(userData).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        this.isEmailAlreadyRegistered = false;
        this.isUserInofUpdated = true;
        this.googleAnalyticsService.accountTransfer();
        setTimeout(_ => {
          this.getAllActiveUsers(this.filterString);
          this.closeExpandedTab();
        }, 2000);
      }, error => {
        if (error?.responseContext?.exceptionResponse?.statusCode === 406) {
          this.isEmailAlreadyRegistered = true;
        }
      }
      )
    }
  }

  //To check data diff
  checkDiff() {

    let isDataSame = JSON.stringify(this.retaileHQList.sort()) === JSON.stringify(this.copyRetailHQList.sort()) ? true : false;
    if (isDataSame || this.retaileHQList?.length < 2) {
      this.disableSaveChanges = true;
    } else {
      this.disableSaveChanges = false;
    }
  }

  getCompleteUsersData() {
    this.activeUserService.getAllActiveUsers(undefined, this.filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        this.isCompleteUserList = true;
        this.completeUserList = (response?.user as ActiveUsers[]);
      });
  }

  //IIT3-1119 (IIT2-9960,9963)
  //For multiselect
  EnableDeleteMultipleStores() {
    this.multiSelectClicked = true;
    this.selectDeSelectAllFlag = false;
    if (this.selectedCountValue > 1) {
      this.selectedUsers = {};
      this.dataContainDisableItem = false;
      this.selectedUserRoles = [];
      this.currentSelecteduserList = [];
    }
    if (!this.isCompleteUserList) this.getCompleteUsersData();
  }

  //To engable/ disable Delete selected btn
  checkDisable(forSelectAll?) {
    let checkArr = [];
    for (let i in this.selectedUsers) {
      if (this.selectedUsers[i]) {
        checkArr.push(i);
      }
    }
    if (forSelectAll) {
      return checkArr?.length;
    } else {
      if (checkArr?.length) {
        return false;
      } else return true;
    }
  }
  //To Cancel multiselect
  cancelMultiSelect() {
    this.multiSelectClicked = false;
    this.selectAll = 0;
    this.selectedUsers = {};
    this.selectedUserRoles = [];
    this.disbaleDeleteIcon = false;
    this.currentSelecteduserList = [];
    this.checkUncheck();
  }
  //To reset/set check/uncheck for select/Unselect All.
  checkUncheck() {
    let selectedCount: any = this.checkDisable(1);
    let chkDisable: any = this.checkDisable(1);
    this.selectedCountValue = selectedCount;
    this.checkUncheckFlag = (selectedCount > 0 || this.selectAll > 0) ? (this.selectAll === selectedCount ? true : false) : false;
    if (this.usersDataUserIds.length !== 0) {
      selectedCount++;
    } else {
      selectedCount;
    }
    let dataContainDisableItem = this.dataContainDisableItem ? 1 : 0;
    if (this.paginationCount === chkDisable + dataContainDisableItem) {
      this.selectDeSelectAllFlag = true;
    } else {
      this.selectDeSelectAllFlag = false;
    }
  }
  //select all Stores
  selectDeSelectAll(event, type, userID?, userrole?, username?) {
    let isCheckboxSel = event?.target?.checked;
    if (type === this.globConst.ALL_TEXT) {
      if (!this.retailHQDropdownSelectedValue && this.userRole == this.intelAdmin) {
        event.target.checked = false;
        return false;
      } else {
        this.selectedUsers = {};
        this.selectedUserRoles = [];
        this.currentSelecteduserList = [];
        if (this.completeUserList.length) {
          this.selectAll = this.completeUserList?.length;
          for (let i = 0; i < this.completeUserList?.length; i++) {
            if (this.completeUserList[i]?.role !== this.intelAdmin && this.completeUserList[i]?.userID !== this.usrID) {
              this.selectedUsers[this.completeUserList[i].userID] = isCheckboxSel;
              if (isCheckboxSel) {
                this.selectedUserRoles.push(this.completeUserList[i]?.role);
                this.currentSelecteduserList.push(this.completeUserList[i]?.userID);
              }
            }
          }
          this.checkUncheck();
        }
      }
    } else {
      this.selectedUsers[userID] = isCheckboxSel;
      this.checkUncheck();
      let selUsersList = Object.values(this.selectedUsers);
      let selUserCount: number = (selUsersList.length > 2) ? selUsersList.filter(Boolean).length : 0;
      let filteredUserId = Object.keys(this.selectedUsers).find(key => this.selectedUsers[key] === true);
      if (isCheckboxSel || (selUserCount == 1 && !this.currentSelecteduserList.includes(filteredUserId))) {
        let selUserID = (selUserCount == 1) ? filteredUserId : userID;
        this.selectedUserRoles.push(userrole);
        this.currentSelecteduserList.push(selUserID);
      } else {
        if (this.selectedUserRoles.length && this.currentSelecteduserList.length) {
          let uRoleIndex = this.selectedUserRoles.indexOf(userrole);
          if (uRoleIndex > -1) this.selectedUserRoles.splice(uRoleIndex, 1);
          let uListIndex = this.currentSelecteduserList.indexOf(userID);
          if (uListIndex > -1) this.currentSelecteduserList.splice(uListIndex, 1);
        }
      }
    }
  }

  showMultiUserDelPopup() {
    this.multiDeleteBtn = true;
    if (this.selectedCountValue === 1) {
      const singleUser = this.completeUserList.filter(item => item.userID === this.currentSelecteduserList[0]);
      if (singleUser.length > 0) {
        this.checkedUser = "Are you sure you want to delete " + singleUser[0]?.name + " ?";
      }
    }
    this.openDeleteModalPopup = true; // To open popup
    this.isDeleteConfirm = false;
    this.isDeleted = true; // To show confirmation message
    this.userRoleDeviceExec = (this.selectedUserRoles.length) ? this.selectedUserRoles.every(i => i === 'deviceExecutive') : false;
  }
}
//IIT3-1119 (IIT2-9960,9963) end
